import * as i0 from '@angular/core';
import { InjectionToken, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpManager } from '@pichincha/http';
import { storage } from '@pichincha/typescript-storage';

const HttpInterceptorRequest = new InjectionToken('HttpInterceptorRequest');
const HttpInterceptorResponse = new InjectionToken('HttpInterceptorResponse');

const HttpConfig = new InjectionToken('');
class HttpService extends HttpManager {
}
class HttpModule {
    static forRoot(httpConfig) {
        return {
            ngModule: HttpModule,
            providers: [
                {
                    provide: HttpConfig,
                    useValue: httpConfig,
                },
                {
                    provide: HttpService,
                    useFactory: (httpConfigFact, injector) => {
                        const interceptor = injector.get(HttpInterceptorRequest, null);
                        const interceptorR = injector.get(HttpInterceptorResponse, null);
                        let httpConf = interceptor
                            ? {
                                ...httpConfigFact,
                                interceptorReq: interceptor.bind(injector),
                            }
                            : httpConfigFact;
                        httpConf = interceptorR
                            ? { ...httpConf, interceptorResp: interceptorR.bind(injector) }
                            : httpConf;
                        return new HttpManager(httpConf);
                    },
                    deps: [HttpConfig, Injector],
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: HttpModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: HttpModule, imports: [CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: HttpModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: HttpModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [CommonModule],
                    exports: [],
                }]
        }] });

const INTERCEPTOR_CONFIG_STORAGE = new InjectionToken('INTERCEPTOR_CONFIG_STORAGE');

/**
 * @context Injector angular
 */
function setAuthorization(data) {
    const $this = this;
    const config = $this.get(INTERCEPTOR_CONFIG_STORAGE);
    const instance = storage(config);
    const access_token = instance.get('access_token');
    const auth_token = instance.get('auth_token');
    const api_key = instance.get('api_key');
    const app_name = instance.get('app_name');
    const micro_front = instance.get('micro_front');
    const session_id = instance.get('uuid');
    const language = instance.get('lang');
    const x_device = navigator.userAgent;
    let obj = {};
    obj = access_token
        ? Object.assign(obj, { Authorization: 'Bearer ' + access_token })
        : obj;
    obj = auth_token ? Object.assign(obj, { 'x-auth-token': auth_token }) : obj;
    obj = api_key ? Object.assign(obj, { 'x-api-key': api_key }) : obj;
    obj = app_name ? Object.assign(obj, { 'app-name': app_name }) : obj;
    obj = micro_front ? Object.assign(obj, { 'caller-name': micro_front }) : obj;
    obj = session_id ? Object.assign(obj, { 'x-session': session_id }) : obj;
    obj = language ? Object.assign(obj, { 'x-language': language }) : obj;
    obj = x_device ? Object.assign(obj, { 'x-device': x_device }) : obj;
    data.headers = { ...data.headers, ...obj };
    return data;
}

/**
 * Generated bundle index. Do not edit.
 */

export { HttpInterceptorRequest, HttpInterceptorResponse, HttpModule, HttpService, INTERCEPTOR_CONFIG_STORAGE, setAuthorization };
